import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { baseQuery } from './base.query';
import { PowerBiReportParams, PowerBiReportRequest } from 'common/models/power-bi.model';

export const powerBiApi = createApi({
  reducerPath: 'powerBiApi',
  baseQuery: baseQuery,
  tagTypes: ['PowerBi'],
  endpoints: (builder) => ({
    getPowerBiReport: builder.query<PowerBiReportParams, PowerBiReportRequest>({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.POWER_BI_WORKSPACES}/${args.workspaceId}/reports/${args.powerBiReportId}/embed-parameters`,
        method: 'POST',
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPowerBiReportQuery } = powerBiApi;
